import React, { useMemo } from 'react'
import { useSelector } from 'react-redux'
import { AppState } from '../store'
import { selectedMap } from '../js/simulationChart'
import { commify } from '../js/utils'
import '../assets/css/libs.css'
import '../assets/css/style.css'

function makeSum(profit: number | undefined, principal: number): number | undefined {
  return profit !== undefined ? profit + principal : undefined
}

export function SimulationResult() {
  const { result, selectedIdx } = useSelector((state: AppState) => state.simulation)

  const principal: string | undefined = useMemo(
    () => (result !== undefined ? commify(result.principal) : '- - - - -'),
    [result]
  )
  const sum: string | undefined = useMemo(() => {
    const caseStr = selectedMap(selectedIdx)
    return caseStr !== null && result !== undefined
      ? commify(makeSum(result[caseStr].profit, result.principal))
      : '- - - - -'
  }, [result, selectedIdx])

  const deposit: string | undefined = useMemo(
    () => (result !== undefined ? commify(result.depositAmount) : '- - - - -'),
    [result]
  )

  // TODO タブのコンポーネント化やエラーメッセージなど
  return (
    <React.Fragment>
      <div className="c-grid u-pl54px u-mt16px c-form--result">
        <div className="c-grid__col u-size--w32">
          <div className="c-form-group">
            <span className="c-form-group__sup">投資総額</span>
            <span className="c-form-group__input">
              <input
                type="text"
                placeholder="- - - - -"
                value={principal}
                className="c-form__output u-size--w240px"
                readOnly
              />
              <span className="c-form-group__text--large">円</span>
            </span>
          </div>
        </div>
        <div className="c-grid__col u-size--w34">
          <div className="c-form-group">
            <span className="c-form-group__sup">投資した場合の評価額シミュレーション</span>
            <span className="c-form-group__input">
              <input
                type="text"
                placeholder="- - - - -"
                value={sum}
                className="c-form__output u-size--w240px"
                readOnly
              />
              <span className="c-form-group__text--large">円</span>
            </span>
          </div>
        </div>
        <div className="c-grid__col u-size--w32">
          <div className="c-form-group">
            <span className="c-form-group__sup">預金した場合の総額</span>
            <span className="c-form-group__input">
              <input
                type="text"
                placeholder="- - - - -"
                value={deposit}
                className="c-form__output u-size--w240px"
                readOnly
              />
              <span className="c-form-group__text--large">円</span>
            </span>
          </div>
        </div>
      </div>
    </React.Fragment>
  )
}
